import React from 'react'
import './project.css'
import Footer from '../Footer';
function Project2(){
    return(
        <>
        <div className='container'>
            <div className ='content'>
                <div className='project'>
                <div>
                <h1>About me</h1>
                <div className='project-text'>
                Little me was eager to show my new ultimate Lego robot to my parents, and after years, the same enthusiasm embraced me when my version of the Wall- E robot traced the black and white maze, avoiding objects. That’s where I decided to play with electronic circuits implementing real-world applications. 
                I am capable of adapting to new environments quickly and effectively. 
                I have a habit of trying out new methods, while improving myself and correcting my mistakes eagerly. 
                With all my passions, my main intention is to share and use my knowledge and experiences for the betterment of humankind

                </div>
                </div>
                
                <img src='/image-8.png' className='wrapper' alt=""/>
                </div>
                
                 
            </div>
        </div>
        <Footer/>
        </>
    )
}
export default Project2;